export const blockIconsSocialNotificationsNone = (
	<span className='material-symbols-outlined'>notifications_none</span>
);
